module.exports = __webpack_public_path__ + "img/TF.d9c9ef13.svg";